import { useAcreditacionServicio } from '@colescba/ui'

export const prettyPrintRoute = route => `${route.name}, path=${route.path}`

export const useAccessControl = () => ({
  mixins: [useAcreditacionServicio()],

  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (!vm.acreditaRuta(to)) {
        process.env.VUE_APP_ENV !== 'production' &&
          console.warn(
            `Se redirecciona al home porque el usuario no acredita la ruta ${prettyPrintRoute(to)}`,
          )
        next({ name: 'NotFound' })
        return
      }

      if ('canAccessHook' in vm && !(await vm.canAccessHook())) {
        process.env.VUE_APP_ENV !== 'production' &&
          console.warn(
            `Se redirecciona al home porque el usuario no puede acceder a la ruta ${prettyPrintRoute(
              to,
            )}`,
          )
        next({ name: 'NotFound' })
        return
      }

      next()
    })
  },
})
